export default __webpack_public_path__ + "static/media/commercial-home-carousel.3b8c50aa.jpg";